/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {
    Component, ElementRef, EventEmitter,
    Input, Output, ViewChild
} from '@angular/core';
import {EditorView} from 'prosemirror-view';

/**
 * Image view component.
 */
@Component({
    selector: 'fc-ag-image-view',
    templateUrl: './image-view.component.html',
    styleUrls: ['./image-view.component.scss']
})

export class ImageViewComponent {
    /**
     * Image src.
     */
    @Input() src: string;

    /**
     * Alt text.
     */
    @Input() alt = '';

    /**
     * Title.
     */
    @Input() title = '';

    /**
     * Outer width.
     */
    @Input() outerWidth = '';

    /**
     * Selected.
     */
    @Input() selected = false;

    /**
     * Editor view instance..
     */
    @Input() view: EditorView;

    /**
     * Image resize.
     */
    @Output() imageResize = new EventEmitter();

    /**
     * Image reference.
     */
    @ViewChild('imgEl', {static: true}) imgEl: ElementRef;

    /**
     * Start resizing callback.
     * 
     * @param e Mouse event.
     * @param direction String.
     */
    startResizing(e: MouseEvent, direction: string): void {
        e.preventDefault();
        this.resizeImage(e, direction);
    }

    /**
     * Resize image function.
     * 
     * @param evt Mouse event.
     * @param direction String.
     */
    resizeImage(evt: MouseEvent, direction: string): void {
        const startX = evt.pageX;
        const startWidth = this.imgEl.nativeElement.clientWidth;

        const isLeftResize = direction === 'left';

        const {width} = window.getComputedStyle(this.view.dom);
        const editorWidth = parseInt(width, 10);

        const onMouseMove = (e: MouseEvent) => {
            const currentX = e.pageX;
            const diffInPx = currentX - startX;
            const computedWidth = isLeftResize ? startWidth - diffInPx : startWidth + diffInPx;

            // prevent image overflow the editor
            // prevent resizng below 20px
            if (computedWidth > editorWidth || computedWidth < 20) {
                return;
            }

            this.outerWidth = `${computedWidth}px`;
        };

        const onMouseUp = (e: MouseEvent) => {
            e.preventDefault();

            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);

            this.imageResize.emit();
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }
}
